const FAST_EFFECTIVE_TYPE = "4g"

type NetworkInformationLike = {
    effectiveType?: string
    saveData?: boolean
}

function isNetworkInformation(value: unknown): value is NetworkInformationLike {
    return typeof value === "object" && value !== null
}

export function isSlowConnection(): boolean {
    if (typeof navigator === "undefined") return false
    const connection: unknown = Reflect.get(navigator, "connection")
    if (!isNetworkInformation(connection)) return false
    if (connection.saveData === true) return true
    return (
        connection.effectiveType !== undefined &&
        connection.effectiveType !== FAST_EFFECTIVE_TYPE
    )
}
